import { useBookingSelectOptions } from "PFApp/booking/components/delete_booking_modal/use_booking_select_options";
import { Booking } from "PFCore/types";

import { BookingQuestions } from "./booking_questions";
import css from "./booking_questions.module.scss";
import { BookingSelectOption } from "./booking_questions.types";

type SpecificTimeBookingsQuestionsProps = {
  value: BookingSelectOption;
  onChange: (selectedOption: BookingSelectOption) => void;
  isEditMode?: boolean;
  label: string;
  booking: Booking;
};

export const SpecificTimeBookingsQuestions = ({
  value,
  onChange,
  isEditMode,
  label,
  booking
}: SpecificTimeBookingsQuestionsProps) => {
  const { deleteOptions, updateOptions } = useBookingSelectOptions({
    booking,
    bookingTemplateId: booking.booking_template_id
  });

  return (
    <BookingQuestions
      name="timeBookingQuestions"
      text={label}
      className={css.specificTimeOptions}
      value={value}
      items={isEditMode ? updateOptions : deleteOptions}
      onChange={onChange}
    />
  );
};
